import React from 'react'
import { Link } from '@jsluna/react'

const SiteDisplay = (site, index, currentSite, selectSite) => {
  const selectedIcon = (!!currentSite && 
    currentSite.code === site.code && 
    currentSite.other_name === site.other_name &&
    currentSite.sitetype === site.sitetype) ?
    (<span>✓</span>) : ''

  return (
    <li key={index} className="ln-o-bare-list__item">
      <Link
        cta
        id={`store-select-${site.code}`}
        tabIndex="0"
        href="#"
        onClick={() => selectSite(site)}
      >
        {selectedIcon}<span className="displayName">{site.other_name} ({site.code})</span>
      </Link>
    </li>
  )
}

export default SiteDisplay



// WEBPACK FOOTER //
// ./src/components/SiteDisplay/index.jsx